import "./assets/js/nav-pills.js";
import "./assets/scss/argon-dashboard.scss";
import "./assets/scss/layout/layout.scss";
export default {
  install() {},
};
